import styled from 'styled-components';

export const StyledGhostSection = styled.div<{ textColor: string }>`
  font-family: var(--font-family), Arial;
  display: inline-flex;
  align-items: center;
  position: relative;
  width: 234px;
  height: 32px;

  .section {
    &-bg-img {
      z-index: -1;
      width: 234px;
      height: 32px;
    }

    &-container {
      z-index: 1;
      position: absolute;
      top: 42%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
    }

    &-name {
      color: ${({ textColor }) => textColor};
      font-weight: 950;
      font-size: 16px;
      text-shadow: -1px -1px 0 #8a31d1, 1px -1px 0 #8a31d1, -1px 1px 0 #8a31d1,
        1px 1px 0 #8a31d1;
      text-transform: uppercase;
    }

    &-coin {
      height: 16px;
      width: 16px;
      margin-right: 4px;

      .image {
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }
  }
`;
